import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class UsersGroupsAPI extends APIBase{

  constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
    super(authHttp, router, session);

    // Entidade principal
    this.__entity = 'users_groups';
  }
}


// WEBPACK FOOTER //
// ./src/api/users_groups.api.ts